import React from "react";
import Title from "../header/Title";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ListCategory from "./ListCategory";
const Categories: React.FC = () => {
  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Title
          title="Product Categories"
          subtitle="Managing the Product Categories"
        />
        <Box>
          <Button
            variant="contained"
            component={Link}
            to="/AddCategory/0"
            sx={{ fontSize: "14px", padding: "10px 12px" }}
          >
            <AddIcon sx={{ mr: "4px" }} />
            Add New
          </Button>
        </Box>
      </Box>
      <ListCategory />
    </React.Fragment>
  );
};

export default Categories;
